import React from 'react';

const BSLAExternalLinkComponent: React.FC<{ href: string; label?: string }> = (props) => {
    return (
        <a href={props.href} target="_blank" rel="noopener noreferrer" className="float-right">
            {props.label ? props.label : 'More Info'}
            <span className="esri-icon-link-external ml-1" />
        </a>
    );
};

export default BSLAExternalLinkComponent;
